import { FigureVarDataDto, isFigureVarDataDto } from "./FigureVarDataDto";

/**
 * Represents data for a single regression line within a figure.
 */
export interface FigureRegressionLineDataDto {
  id: string;
  lineType: string;
  properties: FigureVarDataDto[];
}

/**
 * Type guard to check if an object is a FigureRegressionLineDataDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the regression line data shape.
 */
export const isFigureRegressionLineDataDto = (obj: unknown): obj is FigureRegressionLineDataDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureRegressionLineDataDto;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.lineType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((property) => !isFigureVarDataDto(property))) {
    return false;
  }
  return true;
};
